import { Input } from '@orobix/orobix-fe-components'
import { useField, useFormikContext } from 'formik'
import generate from 'project-name-generator'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

export interface TrainingNameProps {
  fieldName: string
}

type E = React.ChangeEvent<HTMLInputElement>

const TrainingName = ({ fieldName }: TrainingNameProps) => {
  const { t } = useTranslation()
  const { isSubmitting } = useFormikContext()
  const [field, meta, helpers] = useField(fieldName)

  const { name, value } = field
  const { error, touched } = meta
  const { setValue, setTouched } = helpers

  useEffect(() => {
    setValue(generate().dashed)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div id="divTrainingNameId">
      <Input
        name={name}
        id={name}
        label={t('Name')}
        type="text"
        value={value}
        onChange={(e: E) => setValue(e.target.value)}
        onBlur={() => setTouched(true)}
        disabled={isSubmitting}
        error={!!(error && touched)}
        errorMessage={error}
        maxLength={50}
      />
    </div>
  )
}

export default TrainingName
